<template>
  <v-container>
    <v-row
      align="center"
    >
      <v-col
        cols="auto"
      >
        <div class="title text-uppercase font-weight-medium">
          Browse Clients
        </div>
      </v-col>
      <v-spacer />
      <v-col cols="auto">
        <v-text-field
          v-model="filters.name"
          solo
          placeholder="Search"
          flat
          dense
          hide-details
          clearable
          append-icon="fas fa-search"
        />
      </v-col>
      <v-col cols="auto">
        <v-btn
          dark
          color="primary"
          class="ma-0"
          @click="editClientDialog.client = undefined; editClientDialog.visible = true"
        >
          <v-icon
            left
            small
          >
            fas fa-plus
          </v-icon>
          Add New
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <!--<editor-fold desc="Filters">-->
      <!--      <filters-column-->
      <!--        :filters-active="filtersActive"-->
      <!--        @filters:clear-all="clearFilters()"-->
      <!--      />-->
      <!--</editor-fold>-->

      <!--<editor-fold desc="Table">-->
      <v-col>
        <pagination
          :page.sync="items.pagination.page"
          :last-page="items.meta.last_page"
          :total="items.meta.total"
          :from="items.meta.from"
          :to="items.meta.to"
        />
        <v-data-table
          :headers="headers"
          :items="items.data"
          :server-items-length="items.meta.total"
          :sort-by.sync="items.sorting.sortBy"
          :sort-desc.sync="items.sorting.desc"
          :page.sync="items.pagination.page"
          :items-per-page="items.pagination.perPage"
          :loading="items.loading"
          hide-default-footer
          must-sort
          class="v-data-table--striped elevation-15"
          @update:sort-by="fetchItems()"
          @update:page="fetchItems()"
        >
          <template v-slot:item="{ item: client }">
            <tr>
              <td>
                <div class="subtitle-2 primary--text">
                  {{ client.name }}
                </div>
              </td>
              <td>
                  <v-chip
                    small
                    :color="client.proxy_player_downloads ? 'green darken-1' : 'red darken-1'"
                    text-color="white"
                    dark
                    class="ma-0"
                  >
                    {{ client.proxy_player_downloads ? ('Proxy (' + client.player_proxy_download_speed + ' Mbps)') : 'No Proxy' }}
                  </v-chip>
              </td>
              <td>
                <div>
                  {{ $dayjs(client.created_at).format('DD.MM.YYYY. HH:mm:ss') }}
                </div>
              </td>
              <td
                class="text-no-wrap"
                style="width: 1px"
              >
                <v-menu
                  offset-y
                  min-width="100px"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      color="grey"
                      small
                      v-on="on"
                    >
                      <v-icon small>
                        fa fa-ellipsis-v
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list
                    dense
                    class="body-2"
                  >
                    <v-list-item @click="editClientDialog.client = client; editClientDialog.visible = true">
                      <v-list-item-icon>
                        <v-icon small>
                          fa fa-pen
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>Edit Client</v-list-item-content>
                    </v-list-item>
                    <v-divider />
                    <v-list-item @click="editClientDialog.client = client; deleteConfirmationDialogVisible = true">
                      <v-list-item-icon>
                        <v-icon small>
                          fa fa-trash
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>Delete client</v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
        </v-data-table>
        <div class="pa-2">
          <pagination
            :page.sync="items.pagination.page"
            :last-page="items.meta.last_page"
            :total="items.meta.total"
            :from="items.meta.from"
            :to="items.meta.to"
          />
        </div>
      </v-col>
    </v-row>

    <edit-client-dialog
      :visible.sync="editClientDialog.visible"
      :client="editClientDialog.client"
      @client:created="fetchItems()"
      @client:updated="fetchItems()"
    />

    <confirm-delete-dialog
      :visible.sync="deleteConfirmationDialogVisible"
      :submitting="deleting"
      text="Are you sure you want to delete the client?"
      @confirm="deleteClient(editClientDialog.client)"
    />
  </v-container>
</template>

<script>
import fetchableItemsMixin from '@/mixins/fetchableItemsMixin'
import { cloneDeep } from 'lodash'
import ClientModel from '@/models/ClientModel'
import Clients from '@/services/Clients'
// import EditClientDialog from '@/components/clients/EditClientDialog'
import deleteConfirmationMixin from '@/mixins/deleteConfirmationMixin'
import EditClientDialog from '@/components/clients/EditClientDialog'
import ConfirmDeleteDialog from '@/components/helpers/ConfirmDeleteDialog'

export default {
  name: 'Clients',
  components: {
    ConfirmDeleteDialog,
    EditClientDialog
  },
  mixins: [fetchableItemsMixin, deleteConfirmationMixin],
  data() {
    return {
      editClientDialog: {
        visible: false,
        client: undefined
      }
    }
  },
  beforeCreate() {
    this.emptyFilters = cloneDeep(ClientModel.emptyFilters)
  },
  created() {
    this.headers = [
      { text: 'Name', value: 'description' },
      { text: 'Proxy Player Downloads', value: 'proxy_player_downloads' },
      { text: 'Created At', value: 'created_at' },
      { sortable: false }
    ]
  },
  methods: {
    async itemsFetcher(queryParams) {
      return await Clients.fetch(queryParams)
    },
    async deleteClient(client) {
      try {
        await Clients.delete(client.id)

        this.$store.dispatch('alert', {
          text: 'Successfully deleted',
          color: 'success'
        })

        this.fetchItems()
      } catch (e) {
        this.$store.dispatch('alert', {
          text: 'Something went wrong',
          color: 'error'
        })
        throw e
      } finally {
        this.deleteConfirmationDialogVisible = false
        this.deleting = false
      }
    }
  }
}
</script>
